/*
Item: Calc Dialog component for calculating and creating "Wertmerkmal" from Statistics.jsx
Name: CalcDialog
Format: Code/Frontend component
*/

import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { Button } from 'primereact/button';
import { Steps } from 'primereact/steps';
import { Dialog } from 'primereact/dialog';
import { InputText } from 'primereact/inputtext';
// import { MultiSelect } from 'primereact/multiselect';
import { Growl } from 'primereact/growl';
import { InputTextarea } from 'primereact/inputtextarea';
import { ProgressSpinner } from 'primereact/progressspinner';
import { DataTable } from 'primereact/datatable';
import { TabView, TabPanel } from 'primereact/tabview';
import { Column } from 'primereact/column';
import { Slider } from 'primereact/slider';
import valueTemplate from '../../service/data/TemplateValue.json';
import JsonHelper, { StatisticsNames } from '../../utils/statisticsUtils';
import '../../styles/calcDialog.css';
import { MultiLanguage } from '../../utils/MultiLanguage';
import { DropdownLabeled, MultiSelectLabeled } from '../DropdownLabeled';
import MessageService from '../../service/MessageService';

export default class CalcDialog extends Component {
  constructor(props) {
    super(props);
    this.messageService = new MessageService();
    const { closeDialogue, prepareElements } = this.props;
    this.closeDialogue = closeDialogue;
    this.prepareElements = prepareElements;
    this.multiLanguage = new MultiLanguage();
    this.state = this.getInitialState();
  }

  getInitialState = () => ({

    // counter for filter tabs added
    counter: 0,
    selectedTabId: [],
    activeIndexTab: 0,
    valueStatistics: undefined,
    klassifikation: [],
    auspraegung: [],
    auspraegungen: [],
    globalFilter: [],
    measureUnits: this.props.measureUnits,
    step: 0,
    statistiktext: '',
    statistiktext2: '',
    masseinheit: 'ANZAHL',
    selectedId: [],
    selectedWertmerkmal: [],
    selectedStatistic: [],
    selectedMeasure: [],
    selectedLabel: [],
    selectedData: [],
    selectedDecimal: [],
    selectedClassifications: [],
    selectedExpressions: [],
    wertmerkmal2: [],
    // *** filters:
    filterObject: [],
    attributeOptions: [],
    attributeValue: [],
    selectedData2: [],
    selectedDataObj: [],
    selectedIdObj: [],
    selectedClassificationsObj: [],
    selectedExpressionsObj: [],
    formula1: [],
    // *** end filters
    formula: '',
    valueStatistics2: [],
    valueMeasure: undefined,
    valueMeasure2: [],
    valueDecimal: 0,
    merkmalName: undefined,
    merkmalDescription: undefined,
    elements: Object.assign({}, 
      ...this.props.selectedStatistics.map((statistic) => ({
        [statistic.value] : { 
            TIME_IDENTIFYING: [],
            TIME_CLASSIFYING: [],
            VALUE: [],
            REGION_CLASSIFYING: [],
            SUBJECT_CLASSIFYING: [],
            RULE: [],}}
      ))),
    elements1: {
      TIME_IDENTIFYING: [],
      TIME_CLASSIFYING: [],
      VALUE: [],
      REGION_CLASSIFYING: [],
      SUBJECT_CLASSIFYING: [],
      RULE: [],
    },
  })

  checkMatch(obj, itemName, searchStr) {
    let hasMatch = false;
    for (let i = 0; i < obj.length; i += 1) {
      let item = obj[i];
      if (item[itemName] === searchStr) {
        hasMatch = true;
        break;
      }
    }
    return hasMatch;
  }

  handleAdd(wertmerkmal, statistic, measure, label) {
    const line = {
      wertmerkmal: '', statistic: '', measure: '', label: '',
    };
    const {
      selectedId, selectedWertmerkmal, selectedStatistic,
      selectedMeasure, selectedLabel, selectedTabId,
    } = this.state;
    let { counter } = this.state;
    let id = 0;
    id = selectedWertmerkmal.length;
    let { selectedData } = this.state;
    selectedData = JsonHelper.deepCopy(selectedData);
    let valueMeasure2 = 'ANZAHL';
    if (statistic === '21371') {
      valueMeasure2 = 'EUR';
    }
    /* 2116
    if (this.checkMatch(selectedData, 'wertmerkmal', wertmerkmal)) {
      this.handleButton('error', 'Hinweis', 'Merkmal wurde bereits hinzugefügt.');
    } else
    */
    if (wertmerkmal && wertmerkmal !== '' && wertmerkmal.length > 0) {
      line.wertmerkmal = wertmerkmal;
      line.tabHeader = wertmerkmal;
      line.measure = measure;
      line.label = label;
      line.id = wertmerkmal + counter;
      selectedId.push(id);
      selectedTabId.push(wertmerkmal + counter);
      selectedWertmerkmal.push(wertmerkmal);
      selectedStatistic.push(statistic);
      selectedMeasure.push(measure);
      selectedLabel.push(label);
      selectedData.push(line);
      counter += 1;
      this.setState({
        counter,
        selectedId,
        selectedTabId,
        selectedWertmerkmal,
        selectedStatistic,
        selectedData,
        wertmerkmal2: '',
        valueMeasure2,
      });
    } else {
      this.handleButton('error', 'Hinweis', 'Es wurde kein Merkmal gewählt.');
    }
  }

  handleDeleteInTab(obj, tabName) {
    const { filterObject, selectedDataObj } = this.state;
    if (tabName) {
      for (let i = 0; i < filterObject[tabName].length; i += 1) {
        if (obj.classification === filterObject[tabName][i].classification[0]) {
          // entferne ausgewählten Eintrag
          filterObject[tabName].splice(i, 1);
          selectedDataObj[tabName].splice(i, 1);
        }
      }
      // zurückschreiben
      this.setState({ filterObject, selectedDataObj });
    }
  }

  handleDelete(obj) {
    const {
      selectedTabId,
      selectedWertmerkmal,
      selectedStatistic,
      selectedMeasure,
      selectedData,
      selectedId,
    } = this.state;
    let wertmerkmal = JsonHelper.deepCopy(selectedWertmerkmal);
    let statistic = JsonHelper.deepCopy(selectedStatistic);
    let measure = JsonHelper.deepCopy(selectedMeasure);
    let data = JsonHelper.deepCopy(selectedData);
    let tabId = JsonHelper.deepCopy(selectedTabId);
    let id = selectedId;
    const c = obj.wertmerkmal;
    for (let i = 0; i < wertmerkmal.length; i += 1) { // find classification
      if (c === wertmerkmal[i]) { // get index i
        if (i === 0) {
          wertmerkmal.shift();
          statistic.shift();
          measure.shift();
          data.shift();
          tabId.shift();
          id.shift();
        } else if (i === wertmerkmal.length - 1) {
          wertmerkmal.pop();
          statistic.pop();
          measure.pop();
          data.pop();
          tabId.pop();
          id.pop();
        } else {
          // remove entry from classification, expression, and data
          wertmerkmal = wertmerkmal.slice(0, i).concat(
            wertmerkmal.slice(i + 1, wertmerkmal.length),
          );
          statistic = statistic.slice(0, i).concat(statistic.slice(i + 1, statistic.length));
          measure = measure.slice(0, i).concat(measure.slice(i + 1, measure.length));
          data = data.slice(0, i).concat(data.slice(i + 1, data.length));
          tabId = tabId.slice(0, i).concat(tabId.slice(i + 1, tabId.length));
          id = id.slice(0, i).concat(id.slice(i + 1, id.length));
        }
        this.setState({
          selectedId: id,
          selectedTabId: tabId,
          selectedWertmerkmal: wertmerkmal,
          selectedStatistic: statistic,
          selectedMeasure: measure,
          selectedData: data,
        });
        return;
      }
    }
  }

  handleButton(severity, summary, detail) {
    this.growl.show({ severity, summary, detail });
  }

  async handleAttributeValueChange(e) {
    this.setState({ attributeValue: e.value });
  }

  async handleWertmerkmal2Change(e) {
    this.setState({ wertmerkmal2: e.value });
  }

  async handleStatisticChange(e) {
    this.setState({ measureUnits: this.props.measureUnits });
    const valueStatistics = e.value;
    let valueMeasure = 'ANZAHL';
    if (e.value === '21371') {
      valueMeasure = 'EUR';
    }
    let statistiktext;
    statistiktext = StatisticsNames[valueStatistics];
    this.setState({
      valueStatistics,
      statistiktext,
      valueMeasure,
    });
  }

  async handleStatistic2Change(e) {
    this.setState({ measureUnits: this.props.measureUnits, visible: true });
    const valueStatistics2 = e.value;
    let valueMeasure2 = 'Anzahl';
    if (e.value === '21371') {
      valueMeasure2 = 'EUR';
    }
    const statistiktext2 = StatisticsNames[valueStatistics2];
    await this.getDataFromStat(e);
    this.setState({
      visible: false,
      valueStatistics2,
      valueMeasure2,
      statistiktext2,
    });
  }

  async handleMeasureChange(e) {
    this.setState({
      valueMeasure: e.value,
    });
  }

  async handleMeasure2Change(e) {
    this.setState({
      valueMeasure2: e.value,
    });
  }

  async handleDecimalChange(e) {
    this.setState({
      valueDecimal: e.value,
    });
  }

  async handleAddInTab(classification, expression, entryObj) {
    const entryName = entryObj.id;
    const line = { classification: '', expression: '' };
    if (expression) {
      const {
        selectedIdObj, selectedDataObj, filterObject,
        selectedClassificationsObj,
        selectedExpressionsObj,
      } = this.state;
      let selectedId = selectedClassificationsObj[entryName];
      let selectedClassifications = selectedExpressionsObj[entryName];
      let selectedExpressions = selectedDataObj[entryName];
      if (selectedClassificationsObj) {
        selectedId = [0];
        selectedClassifications = [];
        selectedExpressions = [];
      }
      let id = 0;
      id = selectedClassifications.length;
      if (selectedId[selectedClassifications.length - 1]) {
        id = selectedId[selectedClassifications.length - 1] + 1;
      }
      const tmp1 = [];
      // let tmp;
      for (let i = 0; i < expression.length; i += 1) {
        tmp1.push(expression[i].value);
      }
      const tmp = tmp1.join(', ');
      // let { selectedData2 } = this.state;
      let selectedData2 = selectedDataObj[entryName];
      if (!selectedData2) selectedData2 = [];
      if (!this.checkMatch(selectedData2, 'classification', classification)) {
        line.classification = classification;
        line.expression = tmp;
        // selectedId.push(id);
        selectedClassifications.push(classification);
        if (!filterObject[entryObj.id]) {
          filterObject[entryObj.id] = [{ classification: selectedClassifications, expression: tmp1 }];
        } else {
          filterObject[entryObj.id].push({ classification: selectedClassifications, expression: tmp1 });
        }
        selectedExpressions.push(expression);
        selectedData2.push(line);
        // selectedIdObj[entryName] = selectedId;
        selectedClassificationsObj[entryName] = selectedClassifications;
        selectedExpressionsObj[entryName] = selectedExpressions;
        selectedDataObj[entryName] = selectedData2;
        // console.log('FILTER#', filterObject);
        this.setState({
          filterObject,
          // selectedId,
          selectedClassifications,
          // selectedIdObj,
          selectedClassificationsObj,
          selectedExpressionsObj,
          selectedDataObj,
          auspraegung: [],
          auspraegungen: [],
          klassifikation: [],
        });
      } else {
        this.handleButton('error', 'Hinweis', 'Klassifikation wurde bereits hinzugefügt.');
      }
    } else {
      this.handleButton('error', 'Hinweis', 'Es wurde keine Ausprägung gewählt.');
    }
  }

  async getDataFromStat(e) {
    try {
      this.setState({
        elements1: {
          TIME_IDENTIFYING: [],
          TIME_CLASSIFYING: [],
          VALUE: [],
          REGION_CLASSIFYING: [],
          SUBJECT_CLASSIFYING: [],
          RULE: [],
        },
      });

      const selectedStat = [{ name: e.value }];
      // Abruf der Statistik ähnelt dem aus Statistics.jsx (in componentDidMount)
      const elementsData = await this.messageService.postDataStockProperties(selectedStat, 'structureElementsListFromStatistic', 'structure', this.returnLandString());
      const { entrys } = elementsData.data.contents['genesis.container.content.GenesisTMContent'].transfermodel;
      const elementsList = this.prepareElements(entrys);
      const { elements, elements1 } = this.state;
      elements[e.value] = {
          TIME_IDENTIFYING: [],
          TIME_CLASSIFYING: [],
          VALUE: [],
          REGION_CLASSIFYING: [],
          SUBJECT_CLASSIFYING: [],
          RULE: [],
        }
      // split axesList to vars
      for (let i = 0; i < elementsList.length; i += 1) {
        if (elementsList[i].type !== 'UNDEF') {
          if (!(elementsList[i].code.substr(0, 4) === 'SEED' && elementsList[i].type === 'VALUE')) {
            elements[e.value][elementsList[i].type].push(elementsList[i]);
          }
        }
      }
      const elementsData1 = await this.messageService.postDataStockProperties(selectedStat, 'algorithmruleStructureElementsListFromStatistic', 'structure', this.returnLandString());
      if (elementsData1[1] !== 'error') {
        const elementsAr = elementsData1.data.contents['genesis.container.content.GenesisTMContent'].transfermodel.entrys;
        const elementsList1 = this.prepareElements(elementsAr);
        for (let i = 0; i < elementsList1.length; i += 1) {
          if (elementsList1[i].type !== 'UNDEF') {
            if (!(elementsList1[i].code.substr(0, 4) === 'SEED' && elementsList1[i].type === 'VALUE')) {
              elements1[elementsList1[i].type].push(elementsList1[i]);
            }
          }
        }
      }
      this.setState({
        elements, elements1,
      });
      // Zuweisung der Elemente aus der jeweiligen Statistik
      const { VALUE, SUBJECT_CLASSIFYING, REGION_CLASSIFYING } = this.state;
      this.wertmerkmale = VALUE;
      this.subjectRegion = SUBJECT_CLASSIFYING;
      this.subjectRegion1 = REGION_CLASSIFYING;
    } catch (error) {
      console.log('Error in getDataFromStat', error);
    }
  }

  // not used atm
  async getDataFromStats() {
    try {
      // Abruf der Statistik ähnelt dem aus Statistics.jsx (in componentDidMount)
      const { selectedStatistics } = this.props;
      const elementsData = await this.messageService.postDataStockProperties(selectedStatistics, 'structureElementsListFromStatistic', 'structure', this.returnLandString());
      const { entrys } = elementsData.data.contents['genesis.container.content.GenesisTMContent'].transfermodel;

      for (let ii = 0; ii < entrys.length; ii += 1) {
        entrys[ii].uniqueId = '';
        entrys[ii].activeFilter = false;
        entrys[ii].id = ii;
        entrys[ii].text = `${this.multiLanguage.returnInLanguage(entrys[ii], 'de')} [${entrys[ii].name}]`;
        entrys[ii].title = `${this.multiLanguage.returnInLanguage(entrys[ii], 'de')} [${entrys[ii].name}]`;
        entrys[ii].code = entrys[ii].name;
        entrys[ii].children = [];
        entrys[ii].expanded = true;
        entrys[ii].type = entrys[ii].variableType;
        entrys[ii].inhalt = this.multiLanguage.returnInLanguage(entrys[ii], 'de');
      }
      const elementsList = entrys;
      const { elements } = this.state;
      // split axesList to vars
      for (let i = 0; i < elementsList.length; i += 1) {
        if (elementsList[i].type !== 'UNDEF') {
          if (!(elementsList[i].code.substr(0, 4) === 'SEED' && elementsList[i].type === 'VALUE')) {
            elements[elementsList[i].type].push(elementsList[i]);
          }
        }
      }
      this.setState({
        elements,
      });

      // Zuweisung der Elemente aus der jeweiligen Statistik
      const { VALUE, SUBJECT_CLASSIFYING, REGION_CLASSIFYING } = this.state;
      this.wertmerkmale = VALUE;
      this.subjectRegion = SUBJECT_CLASSIFYING;
      this.subjectRegion1 = REGION_CLASSIFYING;
    } catch (error) {
      console.log('Error in getDataFromStat', error);
    }
  }

  returnLandString = () => {
    // returnLandString() {
    const regional = sessionStorage.getItem('evaluationRegional');
    let isLandString = 'false';
    if (regional === 'Land') isLandString = 'true';
    return isLandString;
  }

  actionTemplate(obj, entryName) {
    // console.log('DEL#2', entryName);
    const deleteBasic = (
      <div>
        <Button
          id="delete"
          icon="pi-md-delete-forever"
          onClick={() => this.handleDelete(obj)}
          className="p-button-danger"
          tooltip="Eintrag löschen"
          tooltipOptions={{ position: 'left' }}
        />
      </div>
    );
    const deleteFilter = (
      <div>
        <Button
          id="delete"
          icon="pi-md-delete-forever"
          onClick={() => this.handleDeleteInTab(obj, entryName)}
          className="p-button-danger"
          tooltip="Eintrag löschen"
          tooltipOptions={{ position: 'left' }}
        />
      </div>
    );
    const actions = entryName ? deleteFilter : deleteBasic;
    return actions;
  }

  async toggleSave() {
    const ret = await this.messageService.postVariableValueBuildRuleinit();
    const ret2 = await this.messageService.postVariableValueBuildVariableinit();
    const ret3 = await this.messageService.getCreatehelperCreatetextobject();
    const {
      valueStatistics, valueMeasure, valueDecimal, formula, selectedWertmerkmal, filterObject,
      selectedStatistic, selectedMeasure, merkmalName, merkmalDescription, formula1,
      selectedTabId,
    } = this.state;
    const retData = ret3.data;
    const merkmal = JsonHelper.deepCopy(ret2.contents['genesis.container.content.GenesisTMContent'].transfermodel);
    const shortText = JsonHelper.deepCopy(retData);
    shortText.langText[0].text = merkmalDescription;
    merkmal.name = merkmalName;
    merkmal.shortDescription = shortText;
    const rule = JsonHelper.deepCopy(ret);
    rule.contents['genesis.container.content.GenesisTMContent'].transfermodel.targetVariable = merkmalName;
    rule.contents['genesis.container.content.GenesisTMContent'].transfermodel.targetVariableReference = merkmal;
    rule.contents['genesis.container.content.GenesisTMContent'].transfermodel.statistic = valueStatistics;
    rule.contents['genesis.container.content.GenesisTMContent'].transfermodel.measureUnit = valueMeasure;
    rule.contents['genesis.container.content.GenesisTMContent'].transfermodel.decimals = valueDecimal;
    rule.contents['genesis.container.content.GenesisTMContent'].transfermodel.formula = formula;
    const templateBaseVariable = await this.messageService.getVariableValueBuildCreateBaseVariable();
    for (let i = 0; i < selectedWertmerkmal.length; i += 1) {
      if (selectedWertmerkmal[i]) {
        const theId = selectedTabId[i];
        // Ausgewählte Basiswertmerkmale der Berechnung in Json einfügen
        const basisMerkmal = JsonHelper.deepCopy(templateBaseVariable);
        basisMerkmal.baseVariable = selectedWertmerkmal[i];
        basisMerkmal.baseVariableStatistic = selectedStatistic[i];
        basisMerkmal.baseVariableMeasureUnit = selectedMeasure[i];
        // nicht zu vergessen: yearreference, formula, filterVariables:
        basisMerkmal.yearreference = null;
        const fo = formula1[theId] ? formula1[theId] : '';
        basisMerkmal.formula = fo;
        const filterVariables = [];
        if (filterObject[theId]) {
          const filter = filterObject[theId];
          for (let k = 0; k < filter.length; k += 1) {
            filterVariables[k] = {
              '@class': 'genesis.transfer.model.gom.statistic.metadata.RuleBaseVariableFilterObject',
              filterVariableName: filter[k].classification[0],
              filterVariable: null,
              filterValueName: filter[k].expression,
              filterValue: [],
              selected: false,
            };
          }
        }
        basisMerkmal.filterVariables = filterVariables;
        const deepCopyBasisMerkmal = JsonHelper.deepCopy(basisMerkmal);
        rule.contents['genesis.container.content.GenesisTMContent'].transfermodel.baseVariableReferences[i] = deepCopyBasisMerkmal;
      }
    }
    let returnMessage = ['', 'error'];
    if (merkmalName.length > 0 && merkmalDescription.length > 0) {
      if (valueStatistics.length > 0) {
        if (valueMeasure.length > 0) {
          if (selectedStatistic.length > 0) {
            if (formula.length > 0) {
              // console.log('FILTER#5', rule);
              // return;
              returnMessage = await this.messageService.postVariableValueBuildInsert(rule);
            } else {
              returnMessage = ['Bitte geben Sie eine Formel zur Berechnung ein', 'error'];
            }
          } else {
            returnMessage = ['Bitte wählen Sie mindestens ein Merkmal als Operand für die Berechnung aus', 'error'];
          }
        } else {
          returnMessage = ['Maßeinheit des Ergebnismerkmals fehlt', 'error'];
        }
      } else {
        returnMessage = ['Statistik des Ergebnismerkmals fehlt', 'error'];
      }
    } else {
      returnMessage = ['Merkmalname und/oder Merkmalbeschreibung des Ergebnismerkmals fehlt', 'error'];
    }

    if (!returnMessage) returnMessage = ['Unbekannter Fehler', 'error'];

    if (returnMessage[1] === 'error') {
      this.growl.show({
        life: 12000, severity: returnMessage[1], summary: 'Fehler', detail: returnMessage[0],
      });
    } else {
      this.setState(this.getInitialState());
      this.closeDialogue(true);
    }
  }

  toggleCancel() {
    this.setState(this.getInitialState());
    this.closeDialogue(false);
  }

  moveInSteps(direction) {
    let { step } = this.state;
    step += direction;
    this.setState({ step });
  }

  renderFooter(step) {
    const back = <Button disabled={false} className="p-button-primary" label="Zurück" icon="pi pi-chevron-left" onClick={() => this.moveInSteps(-1)} />;
    const forward = <Button disabled={this.isForwardDisabled(step)} className="p-button-primary" label="Weiter" icon="pi pi-chevron-right" onClick={() => this.moveInSteps(1)} />;
    const save = <Button disabled={false} className="p-button-success" label="Speichern" icon="pi pi-check" onClick={() => this.toggleSave()} />;
    // const check = <Button disabled={false} className="p-button-info" label="Prüfen" icon="pi pi-md-playlist-add-check" onClick={() => this.toggleCheck()} />;
    const cancel = <Button className="p-button-danger" label="Abbrechen" icon="pi pi-md-clear" onClick={() => this.toggleCancel()} />;
    const ret = [];

    if (step > 0) ret.push(back);
    if (step < 3) ret.push(forward);
    // if (step === 4) ret.push(check);
    if (step === 3) ret.push(save);

    return (
      <div>
        {ret}
        {cancel}
      </div>
    );
  }

  renderFooterOld() {
    const confirm = <Button disabled={false} className="p-button-success" label="Speichern" icon="pi pi-check" onClick={() => this.toggleSave()} />;
    const cancel = <Button className="p-button-danger" label="Abbrechen" icon="pi pi-md-clear" onClick={() => this.toggleCancel()} />;

    return (
      <div>
        {confirm}
        {cancel}
      </div>
    );
  }

  itemTemplate = (option) => {
    if (option) {
      return (
        `${option.value} - ${option.label}`
      );
    }
    return '';
  }

  selectedItemsTemplate = (option) => {
    if (option) {
      if (this.state.auspraegung[1][this.state.auspraegung[1].length - 1] === option) {
        return (
          <p style={{ display: 'inline' }}>
            {option.value}
          </p>
        );
      }
      return (
        <p style={{ display: 'inline' }}>
          {option.value}
          ,
        </p>
      );
    }
    return '...';
  }

  isForwardDisabled(step) {
    let ret = true;
    const {
      valueStatistics, merkmalName, merkmalDescription, valueMeasure,
      selectedData, formula, selectedDataObj, formula1,
    } = this.state;
    // const checkedForEmpty = formula.trim() !== '';
    // console.log('valueMeasure', valueMeasure);
    const checkStep0 = (valueStatistics && merkmalName && merkmalDescription && valueMeasure);
    const checkStep1 = (selectedData.length > 0 && formula);
    let checkStep2 = (selectedData.length > 0 && formula);
    for (var sel in selectedDataObj) {
      if (selectedDataObj[sel].length > 1) {
        if (formula1[sel]) {
          if (formula1[sel].trim() === '') checkStep2 = false;
        } else {
          checkStep2 = false;
        }
      }
    }
    if (step === 0) {
      if (checkStep0) ret = false;
    } else if (step === 1) {
      if (checkStep1) ret = false;
    } else if (step === 2) {
      if (checkStep2) ret = false;
    }
    return ret;
  }

  returnTabView(entryObj, i) {
    const {
      klassifikation,
      auspraegung, auspraegungen, selectedDataObj, formula1,
      elements, activeIndexTab, selectedStatistic
    } = this.state;
    const entryName = entryObj.id;
    const {SUBJECT_CLASSIFYING, REGION_CLASSIFYING, TIME_CLASSIFYING} = elements[selectedStatistic[activeIndexTab]];
    const entryStatistic = entryObj.statistic;
    const entryLabel = entryObj.label;
    const tmpS = SUBJECT_CLASSIFYING.concat(REGION_CLASSIFYING).concat(TIME_CLASSIFYING);
    let classificationOptions = tmpS.map((entry) => ({
      label: `${entry.name} - ${entry.inhalt}`,
      value: entry.name,
    }));
    classificationOptions = classificationOptions.sort((a, b) => ((a.value > b.value) ? 1 : -1));
    const deepCopy = JsonHelper.deepCopy(valueTemplate).basismerkmal;
    const classificationValue = klassifikation[1];
    const expressionOptions = auspraegungen[1];
    const expressionValue = auspraegung[1];
    // console.log('WERT#4', selectedDataObj[entryName], selectedDataObj);
    // console.log('WERT#5', deepCopy);
    const tabView = deepCopy.map((entry) => {
      // console.log('WERT#6', entry);
      const entryList = selectedDataObj[entryName];
      let hasMoreThanTwo = false;
      if (entryList) {
        if (entryList.length > 1) hasMoreThanTwo = true;
      }
      return (
        <div>
          <div className="p-grid p-fluid">
            <div className="p-col-12 p-lg-12" />
            <div className="p-col-6 p-lg-6">
              <span className="p-float-label">
                <InputText disabled id="label1" value={entryLabel} />
                <label htmlFor="label1">Zählfeld</label>
              </span>
            </div>
            <div className="p-col-2 p-lg-2">
              <span className="p-float-label">
                <InputText disabled id="statistik1" value={entryStatistic} />
                <label htmlFor="statistik1">Statistik</label>
              </span>
            </div>
            <div className="p-col-4 p-lg-4">
              <span className="p-float-label">
                <InputText disabled id="statistik1text" value={StatisticsNames[entryStatistic]} />
              </span>
            </div>
            <div className="card p-col-12 p-lg-12 p-grid">
              <div className="p-col-12 p-lg-12">
                <b>Klassifizierende Merkmale</b>
              </div>
              <div className="p-col-6 p-lg-6">
                <DropdownLabeled
                  id="klassifikation1a"
                  label="Klassifikation"
                  name="klassifikation1a"
                  value={classificationValue}
                  options={classificationOptions}
                  onChange={(e) => this.handleclassifikationChange(e, 1)}
                  showClear
                />
              </div>
              <div className="p-col-5 p-lg-5">
                <MultiSelectLabeled
                  id="auspraegung1a"
                  label="Ausprägung"
                  name="auspraegung1a"
                  value={auspraegung[1]}
                  options={auspraegungen[1]}
                  onChange={(e) => this.handleAuspraegungChange(e, 1)}
                  optionLabel="name"
                  itemTemplate={this.itemTemplate}
                  selectedItemTemplate={this.selectedItemsTemplate}
                />
              </div>
              <div className="p-col-1 p-lg-1">
                <Button
                  id="add"
                  icon="pi-md-plus"
                  onClick={async () => await this.handleAddInTab(classificationValue,
                    expressionValue, entryObj)}
                  className="p-button-success"
                  tooltip="Ausprägung hinzufügen"
                  tooltipOptions={{ position: 'left' }}
                />
              </div>
            </div>
            <div className="p-col-12 p-lg-12">
              <DataTable
                emptyMessage="Bitte fügen Sie mindestens eine Klassifikation hinzu."
                stateKey={`tablestate-tab${entry.tabName}`}
                ref={(el) => { this.dt = el; }}
                value={selectedDataObj[entryName]}
                scrollable
                scrollHeight="154px"
              >
                <Column
                  filter={false}
                  style={{ width: '6em' }}
                  field="classification"
                  header="Klassifikation"
                />
                <Column
                  filter={false}
                  style={{
                    width: '20em',
                    whiteSpace: 'nowrap',
                    overflow: 'hidden',
                    textOverflow: 'ellipsis',
                  }}
                  field="expression"
                  header="Ausprägungen"
                />
                <Column
                  header="Aktionen"
                  body={(ex) => this.actionTemplate(ex, entryName)}
                  style={{ textAlign: 'center', width: '4em' }}
                />
              </DataTable>
            </div>
          </div>

          <div className="p-grid p-fluid">
            <div className="p-col-12 p-lg-12">
              <br />
              <b>
                Logische Verknüpfung der klassifizierenden Merkmale
              {hasMoreThanTwo ? '*' : ''}
              </b>
              <br />
            Reihenfolge der klassifizierenden Merkmale beibehalten, zwischen jedem
            Klassifikationsmerkmal logische Verknüpfung eintragen. Zur Auswahl stehen: <i>(</i>, <i>)</i>, <i>AND</i>, <i>OR</i>
              <p />
              <InputTextarea
                id="formula1"
                rows={1}
                cols={30}
                value={formula1[entryName]}
                onChange={(e) => this.setFormulaObj(entryName, e.target.value.replace(/\n/g, ''))}
                onBlur={(e) => this.setFormulaObj(entryName, e.target.value.toUpperCase())}
                autoResize
              />
            </div>
          </div>
        </div>
      )
    }
    );
    return tabView;
  }

  setFormulaObj(entryName, newValue) {
    const { formula1 } = this.state;
    formula1[entryName] = newValue;
    this.setState({ formula1 });
  }

  async loadValuesShort(merkmaleCode, zeile) {
    const { auspraegungen, auspraegung } = this.state;
    // const deepCopy_auspraegungen = this.state.auspraegungen;
    // const deepCopy_auspraegung = this.state.auspraegung;
    // this.setState({ auspraegung: deepCopy_auspraegung });
    // this.setState({ auspraegungen: deepCopy_auspraegungen });
    if (merkmaleCode === null) {
      auspraegungen[zeile] = '';
      auspraegung[zeile] = '';
    } else {
      const isSecondOption = false;
      const type = 'valueassociation';
      const ttype = 'VARIABLE';
      const objtype = 'ASSOCIATIONVALUETOCLASSIFYINGVARIABLE';
      const elementsData = await this.messageService.postRecordStructureDirectory(merkmaleCode,
        isSecondOption, type, ttype, objtype);
      if (elementsData[1] !== 'error') {
        // map smaller
        const tmp = elementsData.map((entry) => ({
          value: entry.name,
          label: this.multiLanguage.returnInLanguage(entry, 'de'),
        }));
        auspraegungen[zeile] = tmp;
        auspraegung[zeile] = '';
        this.setState({ auspraegungen });
      }
    }
  }

  async handleclassifikationChange(e, zeile) {
    const { klassifikation } = this.state;
    this.setState({ visible: true });
    try {
      await this.loadValuesShort(e.value, zeile);
    } catch (err) {
      // eslint-disable-next-line no-console
      console.log('ERROR in handleclassifikationChange', err);
    } finally {
      this.setState({ visible: false });
      klassifikation[zeile] = e.value;
      this.setState({ klassifikation });
    }
  }

  handleAuspraegungChange(e, zeile) {
    const { auspraegung } = this.state;
    auspraegung[zeile] = e.value;
    this.setState({ auspraegung });
  }

  async handleTabChange(e) {
    this.setState({
      activeIndexTab: e.index,
      klassifikation: [],
      auspraegung: [],
    });
  }

  returnProperties(step) {
    const {
      wertmerkmal2, valueMeasure, valueMeasure2, valueDecimal,
      merkmalName, merkmalDescription, formula, valueStatistics, valueStatistics2,
      selectedData, elements, statistiktext, statistiktext2
    } = this.state;
    const wertmerkmale = elements[valueStatistics2]?.VALUE?.map((entry) => ({
      label: `${entry.name} - ${entry.inhalt}`,
      value: entry.name,
    })) || [];
    let label2 = '';
    for (let i = 0; i < wertmerkmale.length; i += 1) {
      if (wertmerkmale[i].value === wertmerkmal2) {
        label2 = wertmerkmale[i].label;
      }
    }
    const { selectedStatistics } = this.props;
    const page = [];
    const {
      masseinheit, measureUnits, activeIndexTab,
    } = this.state;
    page[0] = (
      <div>
        <div className="card">
          <div className="p-grid p-fluid">
            <div className="p-col-2 p-lg-12">
              <b>Ergebnis der Berechnung</b>
            </div>
            <div className="p-col-2 p-lg-12 p-grid">
              <div className="p-col-2 p-lg-2">
                <b>Merkmal*</b>
              </div>
              <div className="p-col-2 p-lg-2">
                <span className="p-float-label">
                  <InputText maxLength="8" id="merkmalName1" value={merkmalName} onChange={(e) => this.setState({ merkmalName: e.target.value.toUpperCase() })} />
                  <label htmlFor="merkmalName1">Name</label>
                </span>
              </div>
              <div className="p-col-2 p-lg-8">
                <span className="p-float-label">
                  <InputText maxLength="70" id="merkmaltextBer" value={merkmalDescription} onChange={(e) => this.setState({ merkmalDescription: e.target.value })} />
                  <label htmlFor="merkmaltextBer">Beschreibung</label>
                </span>
              </div>
              <div className="p-col-2 p-lg-2">
                <b>Statistik*</b>
              </div>
              <div className="p-col-2 p-lg-2">
                <DropdownLabeled
                  id="statistikBer"
                  label="Auswahl"
                  name="statistik"
                  options={selectedStatistics}
                  value={valueStatistics}
                  onChange={(e) => this.handleStatisticChange(e)}
                />
              </div>
              <div className="p-col-2 p-lg-8">
                <div style={{ height: '15px' }} />
                <InputText disabled id="statistiktext" value={statistiktext} />
              </div>
              <div className="p-col-2 p-lg-2">
                <b>Maßeinheit*</b>
              </div>
              <div className="p-col-2 p-lg-7">
                <DropdownLabeled
                  id="maßeinheitBer"
                  label="Auswahl"
                  name="measure"
                  options={measureUnits}
                  value={valueMeasure}
                  onChange={(e) => this.handleMeasureChange(e)}
                />
              </div>
              <div className="p-col-2 p-lg-3">
                <b>
                  Nachkommastellen: {valueDecimal}
                </b>
                <p />
                <Slider
                  min="0"
                  max="10"
                  step="1"
                  value={valueDecimal}
                  onChange={(e) => this.handleDecimalChange(e)}
                  style={{ width: '10em' }}
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    );
    // const basismerkmal = JsonHelper.deepCopy(valueTemplate).basismerkmal;
    const { basismerkmal } = valueTemplate;
    const page1 = (
      <div>
        <div className="card">
          <div className="p-grid p-fluid">
            <div className="p-col-2 p-lg-12">
              <b>Basisangaben für Berechnung</b>
            </div>
            <div className="card p-col-2 p-lg-12 p-grid">
              <div className="p-col-2 p-lg-11 p-grid">
                <div className="p-col-2 p-lg-2">
                  <b>Statistik*</b>
                </div>
                <div className="p-col-2 p-lg-2">
                  <DropdownLabeled
                    id="statistik2Ber"
                    label="Auswahl"
                    name="statistik2"
                    options={selectedStatistics}
                    value={valueStatistics2}
                    onChange={(e) => this.handleStatistic2Change(e)}
                  />
                </div>
                <div className="p-col-2 p-lg-8">
                  <div style={{ height: '15px' }} />
                  <InputText disabled id="statistiktext1" value={statistiktext2} />
                </div>
                <div className="p-col-2 p-lg-2">
                  <b>Merkmal*</b>
                </div>
                <div className="p-col-2 p-lg-10">
                  <DropdownLabeled
                    id="merkmal2Ber"
                    label="Auswahl"
                    name="merkmal2"
                    options={wertmerkmale}
                    value={wertmerkmal2}
                    onChange={(e) => this.handleWertmerkmal2Change(e)}
                  />
                </div>
                <div className="p-col-2 p-lg-2">
                  <b>Maßeinheit*</b>
                </div>
                <div className="p-col-2 p-lg-10">
                  <DropdownLabeled
                    id="maßeinheitBer"
                    label="Auswahl"
                    name="measure"
                    options={measureUnits}
                    value={valueMeasure2}
                    onChange={(e) => this.handleMeasure2Change(e)}
                  />

                </div>
              </div>
              <div className="p-col-2 p-lg-1" style={{ alignSelf: 'center', paddingLeft: '2em' }}>
                <Button
                  id="add"
                  icon="pi-md-plus"
                  onClick={() => this.handleAdd(wertmerkmal2,
                    valueStatistics2, valueMeasure2, label2)}
                  className="p-button-success"
                  tooltip="Merkmal hinzufügen"
                  tooltipOptions={{ position: 'left' }}
                />
              </div>
            </div>
            <div className="p-col-2 p-lg-6">
              <b>Ausgewählte Operanden für Berechnung*</b>
              (Bitte auf Reihenfolge der Merkmale sowie Großbuchstaben
              und Leerzeichen zwischen Merkmal und Operator achten)
              <div className="p-col-2 p-lg-12">
                <DataTable
                  emptyMessage="Bitte fügen Sie mindestens ein Merkmal mit Maßeinheit hinzu."
                  stateKey={`tablestate-tab${basismerkmal.tabName}`}
                  ref={(el) => { this.dt = el; }}
                  value={selectedData}
                  scrollable
                  scrollHeight="154px"
                >
                  <Column
                    filter={false}
                    style={{ width: '4em' }}
                    field="wertmerkmal"
                    header="Merkmal"
                  />
                  <Column
                    filter={false}
                    style={{
                      width: '4.5em',
                      whiteSpace: 'nowrap',
                      overflow: 'hidden',
                      textOverflow: 'ellipsis',
                    }}
                    field="statistic"
                    header="Statistik"
                  />
                  <Column
                    filter={false}
                    style={{ width: '4em' }}
                    field="measure"
                    header="Maßeinheit"
                  />
                  <Column
                    header="Aktionen"
                    body={(ex) => this.actionTemplate(ex)}
                    style={{ textAlign: 'center', width: '4em' }}
                  />
                </DataTable>
              </div>
            </div>
            <div className="p-col-2 p-lg-6">
              <b>
                Formel der Berechnung*
              </b>
              <br />
              Bitte Operanden eintragen und mit Operatoren verknüpfen.
              <br />
              Es stehen zur Verfügung: (,),+,-,*,/
              <br />
              Operanden und Operatoren müssen durch Leerzeichen getrennt werden.
              <div className="p-col-12 p-lg-12" />
              <InputTextarea
                style={{ outline: '1px solid black' }}
                placeholder="MERKMAL1 / MERKMAL2 + MERKMAL3"
                id="formula1Ber"
                rows={3}
                cols={30}
                value={formula}
                onChange={(e) => this.setState({ formula: e.target.value.replace(/[\r\n]+/gm, '') })}
                onBlur={(e) => this.setState({ formula: e.target.value.toUpperCase() })}
                autoResize
              />
            </div>
          </div>
        </div>
      </div>
    );

    page[1] = page1;
    // console.log('ENTRY#5', selectedData);
    const tPanels = selectedData.map((entry, i) => (
      <TabPanel class="test" key={i} header={entry.tabHeader}>
        {this.returnTabView(entry, i)}
      </TabPanel>
    ));
    page[2] = (
      <div>
        <div>
          Sie haben die Möglichkeit zu jedem ausgewählten Basismerkmal (Zählfeld)
          ein oder mehrere klassifizierende Merkmale als Filter auszuwählen.
          Das Basismerkmal ist durch Klick auf den entsprechenden folgenden Reiter auswählbar:
          <p />
        </div>
        <div>
          <TabView
            activeIndex={activeIndexTab}
            // onTabChange={(e) => this.setState({ activeIndexTab: e.index })}
            onTabChange={(e) => this.handleTabChange(e)}
          >
            {tPanels}
          </TabView>
        </div>
      </div>
    );
    let dpsValueMeasure = '';
    const vm = measureUnits.find((item) => item.value === valueMeasure);
    if (vm) dpsValueMeasure = vm.label;
    page[3] = (
      <div>
        <div className="card">
          <div className="p-grid p-fluid">
            <div className="p-col-12 p-lg-12">
              <b>Zusammenfassung und Speichern</b>
              <p />
              Name:
              {' '}
              {merkmalName}
              {' '}
              -
              {' '}
              {merkmalDescription}
              <br />
              Statistik:
              {' '}
              {valueStatistics}
              {' '}
              -
              {' '}
              {statistiktext}
              <br />
              Maßeinheit:
              {' '}
              {dpsValueMeasure}
              <br />
              Formel:
              {' '}
              {formula}
              <br />
            </div>
          </div>
        </div>
      </div>
    );
    return (page[step]);
  }

  render() {
    const { visible, step } = this.state;
    const interactiveItems = [
      {
        label: 'Angaben',
      },
      {
        disabled: this.isForwardDisabled(0),
        label: 'Basismerkmale',
      },
      {
        disabled: this.isForwardDisabled(1),
        label: 'Filter',
      },
      {
        disabled: this.isForwardDisabled(2),
        label: 'Speichern',
      },
    ];
    return (
      <div>
        <Growl ref={(el) => { this.growl = el; }} />
        <Dialog
          header="Lade Ausprägungen..."
          closable={false}
          closeOnEscape={false}
          visible={visible}
          modal
          onHide={() => this.setState({ visible: false })}
        >
          <div style={{ textAlign: 'center' }}><ProgressSpinner /></div>
        </Dialog>
        <Dialog
          {...this.props}
          footer={this.renderFooter(step)}
          style={{
            overflowY: 'scroll',
            width: '800px',
            top: '10px',
            transform: 'unset',
            left: '400px',
            height: '620px',
          }}
        >
          <Steps
            id="wertmerkmal_bilden"
            model={interactiveItems}
            activeIndex={step}
            onSelect={(e) => this.setState({ step: e.index })}
            readOnly={false}
          />
          {this.returnProperties(step)}
        </Dialog>
      </div>
    );
  }
}

CalcDialog.propTypes = {
  closeDialogue: PropTypes.func.isRequired,
  prepareElements: PropTypes.func.isRequired,
  selectedStatistics: PropTypes.instanceOf(Object).isRequired,
};
